/**
 * Origin Nutrition - GoKwik Slide Cart Theme Adapter
 * Updated product/offer styling overrides
 * File: assets/gokwik-theme-adapter.js
 */

(function() {
  const THEME = {
    bgCream: '#fffaf2',
    bgCard: '#f9eccf',
    brandBrown: '#612d0f',
    ctaOrange: '#ea8b48',
    ctaOrangeHover: '#d97a36',
    discountPillBg: '#F39D52',
    discountPillColor: '#612d0f',
    discountRed: '#fa493d',
    strikeColor: '#62676c',
    borderMuted: 'rgba(97, 45, 15, 0.16)',
    textDark: '#332219',
    white: '#ffffff'
  };

  function applyStyles(shadowRoot) {
    let style = shadowRoot.querySelector('#gokwik-origin-overrides');

    if (!style) {
      style = document.createElement('style');
      style.id = 'gokwik-origin-overrides';
      shadowRoot.appendChild(style);
    }

    style.textContent = `
      /* =======================================================
         1. MAIN BACKGROUND & TYPOGRAPHY
         ======================================================= */

      .sidecart,
      .gokwik-sidecart-container,
      .sidecart.svelte-8dbmhg {
        background-color: ${THEME.bgCream} !important;
        color: ${THEME.textDark} !important;
        font-family: inherit !important;
      }

      .side-cart-header,
      .side-cart-header.svelte-7q687i {
        background-color: ${THEME.bgCream} !important;
        border-bottom: 1px solid ${THEME.borderMuted} !important;
      }

      .header-text,
      .side-cart-header .header-text,
      .side-cart-subHeader p span {
        color: ${THEME.brandBrown} !important;
        font-weight: 700 !important;
        font-size: 16px !important;
      }


      /* =======================================================
         2. COUNTDOWN TIMER
         ======================================================= */

      .countdown-container,
      .countdown-container.svelte-1v56yyr {
        background-color: ${THEME.brandBrown} !important;
        color: ${THEME.white} !important;
        border-radius: 5px !important;
        margin: 4px 8px !important;
        padding: 6px 12px !important;
        width: auto !important;
      }

      .countdown-container p,
      .timer-text,
      .timer-text p {
        color: ${THEME.white} !important;
        font-weight: 600 !important;
        margin: 0 !important;
      }

      .timer-block,
      .timer-block.svelte-1v56yyr {
        background-color: transparent !important;
        border: none !important;
        color: ${THEME.ctaOrange} !important;
        font-size: 14px !important;
        font-weight: 800 !important;
      }


      /* =======================================================
         3. REWARDS & MILESTONES
         ======================================================= */

      .progress-container.svelte-nuzrbq {
        background-color: transparent !important;
      }

      .progress-container .next-milestone-text {
        color: ${THEME.brandBrown} !important;
        font-weight: 700 !important;
      }

      .progress-bar-rail.svelte-nuzrbq {
        background-color: rgba(97, 45, 15, 0.12) !important;
      }

      .progress-bar-fill.svelte-nuzrbq {
        background-color: ${THEME.ctaOrange} !important;
      }

      .steps-wrap.svelte-nuzrbq {
        border-color: ${THEME.brandBrown} !important;
      }

      .steps-wrap.svelte-nuzrbq .icon-wrap {
        border-color: ${THEME.brandBrown} !important;
        background-color: ${THEME.white} !important;
      }

      .steps-wrap.svelte-nuzrbq .icon-wrap svg path {
        stroke: ${THEME.brandBrown} !important;
      }

      .milestone-goal,
      .milestone-text {
        color: ${THEME.brandBrown} !important;
        font-weight: 600 !important;
      }


      /* =======================================================
         4. CART ITEMS & PRICING
         ======================================================= */

      .item-list-wrapper,
      .item-list-wrapper.svelte-6i8smf,
      .product-tile-wrapper,
      .product-tile-wrapper.svelte-10zz03f {
        background-color: transparent !important;
        background: transparent !important;
        border: 1px solid ${THEME.borderMuted} !important;
        border-radius: 10px !important;
        padding: 10px !important;
      }

      .sidecart-product-title.svelte-10zz03f {
        color: ${THEME.brandBrown} !important;
        font-weight: 500 !important;
        font-size: 13px !important;
        line-height: 1.35 !important;
        margin: 0 0 3px !important;
      }

      .final-price.svelte-10zz03f {
        color: ${THEME.discountRed} !important;
        font-weight: 700 !important;
        font-size: 13px !important;
      }

      .item-price strike,
      strike.compare-at-price,
      .compare-at-price.svelte-10zz03f,
      strike.svelte-10zz03f,
      strike.svelte-16y1xw6 {
        display: inline-block !important;
        visibility: visible !important;
        color: #62676c !important;
        font-size: 12px !important;
        text-decoration: line-through !important;
        margin: 0 2px !important;
        font-weight: 400 !important;
      }

      .discount-percentage,
      .discount-percentage.svelte-10zz03f,
      .item-price .discount-percentage,
      .estimated-total-container .discount-percentage,
      span.discount-percentage {
        background-color: ${THEME.discountPillBg} !important;
        color: ${THEME.discountPillColor} !important;
        font-weight: 600 !important;
        font-size: 10px !important;
        line-height: 1.2 !important;
        padding: 2px 5px !important;
        border-radius: 3px !important;
        display: inline-block !important;
      }

      .quantity-handler.svelte-10zz03f {
        background-color: rgba(97, 45, 15, 0.05) !important;
        border: 1px solid ${THEME.borderMuted} !important;
        border-radius: 5px !important;
        height: 32px !important;
      }

      .quantity-handler span,
      .quantity-handler input {
        color: ${THEME.brandBrown} !important;
        font-weight: 700 !important;
        font-size: 13px !important;
      }

      .remove-btn.svelte-10zz03f {
        color: ${THEME.brandBrown} !important;
      }


      /* =======================================================
         5. YOU MAY ALSO LIKE
         ======================================================= */

      .upSell-container,
      .upSell-container.svelte-bmzzto {
        background: transparent !important;
        border: none !important;
        padding: 6px 8px !important;
        margin: 0 !important;
      }

      .upSell-container .title {
        color: ${THEME.brandBrown} !important;
        font-size: 14px !important;
        font-weight: 700 !important;
        margin-bottom: 6px !important;
      }

      .scroll-container.svelte-bmzzto {
        display: flex !important;
        flex-direction: row !important;
        gap: 10px !important;
        overflow-x: auto !important;
        padding-bottom: 6px !important;
      }


      /* =======================================================
         6. UPSELL CARD - FIXED UNIFORM WIDTH (250px)
         ======================================================= */

      .card.svelte-zwa04n,
      .card.svelte-zwa04n.svelte-zwa04n {
        background: ${THEME.bgCard} !important;
        background-color: ${THEME.bgCard} !important;
        border: 1px solid rgba(97, 45, 15, 0.18) !important;
        border-radius: 10px !important;
        box-shadow: none !important;
        padding: 8px !important;
        width: 250px !important;
        min-width: 250px !important;
        max-width: 250px !important;
        flex: 0 0 250px !important;
        box-sizing: border-box !important;
        display: flex !important;
        flex-direction: row !important;
        align-items: center !important;
      }

      .card.svelte-zwa04n .product-main-content,
      .card.svelte-zwa04n .details {
        background: transparent !important;
        border: none !important;
        min-width: 0 !important;
        flex: 1 1 auto !important;
        box-sizing: border-box !important;
      }

      .card.svelte-zwa04n img {
        border-radius: 6px !important;
        object-fit: contain !important;
        flex-shrink: 0 !important;
      }


      /* =======================================================
         7. PRODUCT NAME - 2-LINE WRAP
         ======================================================= */

      .product-name.svelte-zwa04n.svelte-zwa04n,
      .card.svelte-zwa04n .product-name {
        width: 100% !important;
        max-width: 100% !important;
        white-space: normal !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;
        display: -webkit-box !important;
        -webkit-line-clamp: 2 !important;
        -webkit-box-orient: vertical !important;
        line-height: 1.3 !important;
        height: 2.6em !important;
        word-break: break-word !important;
        margin-bottom: 4px !important;
      }

      .card.svelte-zwa04n .product-title,
      .card.svelte-zwa04n h4 {
        color: ${THEME.brandBrown} !important;
        font-size: 12px !important;
        font-weight: 600 !important;
      }


      /* =======================================================
         8. UPSELL PRICES
         ======================================================= */

      .card.svelte-zwa04n .final-price {
        color: ${THEME.discountRed} !important;
        font-weight: 700 !important;
      }

      .price.svelte-zwa04n strike.svelte-zwa04n {
        color: #62676c !important;
      }


      /* =======================================================
         9. DISCOUNT BANNER
         ======================================================= */

      .discount-banner.svelte-zwa04n {
        background: #ea8b48 !important;
        background-color: #ea8b48 !important;
      }


      /* =======================================================
         10. SPECIFIC ADD BUTTON
         ======================================================= */

      .add-btn.svelte-zwa04n.svelte-zwa04n {
        background: unset !important;
        background-color: unset !important;
      }


      /* =======================================================
         11. OTHER ADD BUTTON STYLES
         ======================================================= */

      .add-btn.svelte-zwa04n,
      .card.svelte-zwa04n button,
      .upsell.svelte-10zz03f .add-to-cart {
        border: 1px solid rgba(97, 45, 15, 0.35) !important;
        color: ${THEME.brandBrown} !important;
        font-weight: 700 !important;
        font-size: 11px !important;
        border-radius: 5px !important;
        padding: 4px 10px !important;
        cursor: pointer !important;
      }

      .add-btn.svelte-zwa04n:hover,
      .card.svelte-zwa04n button:hover {
        background: unset !important;
        background-color: unset !important;
        border-color: ${THEME.brandBrown} !important;
        color: ${THEME.brandBrown} !important;
      }


      /* =======================================================
         12. OFFERS & COUPONS BOX
         ======================================================= */

      .offer-box,
      .offer-box.svelte-1l21ak5 {
        background-color: transparent !important;
        background: transparent !important;
        border: 1px solid ${THEME.borderMuted} !important;
        border-radius: 10px !important;
      }

      .discount-input-area.svelte-jkko1w {
        background-color: ${THEME.white} !important;
        border-radius: 6px !important;
      }

      .discount-input-area.svelte-jkko1w input {
        border-color: ${THEME.borderMuted} !important;
        color: ${THEME.brandBrown} !important;
      }

      .discount-icon.svelte-jkko1w svg,
      .discount-icon.svelte-jkko1w svg path {
        color: ${THEME.brandBrown} !important;
        fill: ${THEME.brandBrown} !important;
      }

      .view-offers-button.svelte-1l21ak5,
      .view-offers-button.svelte-1l21ak5 .offers-text {
        color: ${THEME.brandBrown} !important;
        font-weight: 700 !important;
        background: transparent !important;
      }


      /* =======================================================
         13. GREEN BADGES & SHIPPING PILL
         ======================================================= */

      .chip-green,
      .chip-green.svelte-1m27nla,
      .chip.chip-green,
      .coupon-applied-area,
      .coupon-applied-area.svelte-10zz03f {
        background-color: ${THEME.bgCard} !important;
        color: ${THEME.brandBrown} !important;
        border: 1px solid rgba(97, 45, 15, 0.16) !important;
        font-weight: 600 !important;
      }

      .chip-green svg,
      .chip-green.svelte-1m27nla svg {
        color: ${THEME.brandBrown} !important;
        fill: ${THEME.brandBrown} !important;
      }


      /* =======================================================
         14. SAVINGS RIBBON
         ======================================================= */

      .ribbon,
      .ribbon.svelte-1wgo1p4,
      div.ribbon {
        background: ${THEME.brandBrown} !important;
        background-color: ${THEME.brandBrown} !important;
        border-radius: 4px !important;
        box-shadow: 0 2px 5px rgba(97, 45, 15, 0.22) !important;
      }

      .ribbon:before,
      .ribbon:after,
      .ribbon.svelte-1wgo1p4:before,
      .ribbon.svelte-1wgo1p4:after {
        display: none !important;
      }

      .footer-ribbon-text,
      .footer-ribbon-text.svelte-1k58v35,
      p.footer-ribbon-text {
        color: ${THEME.white} !important;
        font-weight: 700 !important;
      }


      /* =======================================================
         15. AMOUNT SAVED
         ======================================================= */

      .amount-saved.svelte-yxrsu,
      .featured-offer.svelte-yxrsu .offer-details .amount-saved.svelte-yxrsu {
        font-size: 10px !important;
        background: rgb(97, 45, 15) !important;
        background-color: rgb(97, 45, 15) !important;
        color: #fff !important;
        padding: 3px 6px !important;
        border-radius: 3px !important;
        line-height: 1.2 !important;
      }


      /* =======================================================
         16. OFFER ICON
         ======================================================= */

      .offer-icon.svelte-yxrsu,
      .offer-icon.svelte-yxrsu svg,
      .offer-icon.svelte-yxrsu svg path,
      .offer-icon.svelte-yxrsu svg g {
        color: #612d0f !important;
        fill: #612d0f !important;
        stroke: #612d0f !important;
      }


      /* =======================================================
         17. ESTIMATED TOTAL & CLEAN ARROW
         ======================================================= */

      .sidecart-footer,
      .sidecart-footer.svelte-16y1xw6 {
        background-color: ${THEME.bgCream} !important;
        border-top: 1px solid ${THEME.borderMuted} !important;
      }

      .estimated-total.svelte-16y1xw6,
      .estimated-total-container span {
        color: ${THEME.brandBrown} !important;
        font-weight: 700 !important;
        font-size: 15px !important;
      }

      .estimated-total-section svg {
        color: ${THEME.brandBrown} !important;
      }

      .breakdown-toggle,
      .breakdown-toggle.svelte-16y1xw6,
      button.breakdown-toggle,
      .estimated-total-section button,
      .estimated-total-container button {
        background: transparent !important;
        background-color: transparent !important;
        border: none !important;
        box-shadow: none !important;
        outline: none !important;
        padding: 0 !important;
        margin: 0 0 0 3px !important;
        width: auto !important;
        height: auto !important;
        min-width: unset !important;
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
      }

      .breakdown-toggle svg,
      .breakdown-toggle.svelte-16y1xw6 svg {
        color: ${THEME.brandBrown} !important;
        fill: currentColor !important;
        background: transparent !important;
      }


      /* =======================================================
         18. ORDER BREAKDOWN
         ======================================================= */

      .order-breakdown,
      .order-breakdown-container,
      .breakdown-list,
      .breakdown-row,
      .breakdown-item {
        color: ${THEME.textDark} !important;
      }

      .breakdown-item span,
      .breakdown-item p,
      .breakdown-item div,
      .breakdown-label,
      .breakdown-value,
      .breakdown-row span,
      .breakdown-row p {
        color: ${THEME.textDark} !important;
      }

      .free-text,
      .free-label,
      .free-shipping-text,
      span.free,
      .breakdown-item .free,
      .breakdown-value.free {
        color: ${THEME.brandBrown} !important;
        font-weight: 600 !important;
      }

      .savings-text,
      .you-save,
      .total-savings {
        color: ${THEME.brandBrown} !important;
      }


      /* =======================================================
         19. PRIMARY CHECKOUT BUTTON
         ======================================================= */

      .sidecart-footer .gokwik-checkout button,
      .gokwik-checkout button.svelte-16y1xw6,
      .sidecart button.svelte-16y1xw6 {
        background-color: ${THEME.ctaOrange} !important;
        background: ${THEME.ctaOrange} !important;
        border-radius: 7px !important;
        border: none !important;
        height: 46px !important;
        box-shadow: 0 3px 10px rgba(234, 139, 72, 0.24) !important;
      }

      .sidecart-footer .gokwik-checkout button:hover {
        background-color: ${THEME.ctaOrangeHover} !important;
      }

      .gokwik-checkout button .btn-content .btn-text,
      .gokwik-checkout button .btn-content .btn-text span,
      .gokwik-checkout button .btn-content .btn-text p,
      .gokwik-checkout button .btn-text p {
        color: ${THEME.white} !important;
        font-size: 14px !important;
        font-weight: 700 !important;
        letter-spacing: 0.04em !important;
        text-transform: uppercase !important;
      }


      /* =======================================================
         20. SAVED AMOUNT & ANY REMAINING APP GREEN / BLUE
         ======================================================= */

      [class*="saved-amount"],
      [class*="savedAmount"],
      [class*="savings"],
      [class*="you-save"],
      [class*="youSave"],
      [class*="cart-saving"],
      [class*="total-saving"],
      .savings-chip,
      .savings-label,
      .savings-value,
      .saving-amount {
        color: ${THEME.textDark} !important;
      }
    `;


    /* =========================================================
       PRODUCT TILE LAYOUT RESTRUCTURE
       ========================================================= */

    shadowRoot.querySelectorAll('.product-tile-wrapper').forEach(function(tile) {
      if (tile.dataset.gkR) return;

      var title = tile.querySelector('.sidecart-product-title');
      var finalPrice = tile.querySelector('.final-price');
      if (!title || !finalPrice) return;

      var priceBlock = finalPrice;
      var cursor = finalPrice.parentElement;
      while (cursor && cursor !== tile) {
        if (cursor.querySelector('.quantity-handler') || cursor.querySelector('.remove-btn')) {
          break;
        }
        priceBlock = cursor;
        cursor = cursor.parentElement;
      }

      title.parentNode.insertBefore(priceBlock, title.nextSibling);

      var titleParent = title.parentElement;
      if (titleParent && titleParent !== tile) {
        titleParent.style.setProperty('display', 'flex', 'important');
        titleParent.style.setProperty('flex-direction', 'column', 'important');
        titleParent.style.setProperty('align-items', 'flex-start', 'important');
      }

      priceBlock.style.setProperty('display', 'flex', 'important');
      priceBlock.style.setProperty('flex-direction', 'row', 'important');
      priceBlock.style.setProperty('align-items', 'center', 'important');
      priceBlock.style.setProperty('flex-wrap', 'wrap', 'important');
      priceBlock.style.setProperty('gap', '5px', 'important');
      priceBlock.style.setProperty('justify-content', 'flex-start', 'important');
      priceBlock.style.setProperty('margin-top', '3px', 'important');
      priceBlock.style.setProperty('margin-bottom', '0', 'important');
      priceBlock.style.setProperty('width', 'auto', 'important');

      tile.dataset.gkR = '1';
    });


    /* =========================================================
       DIRECT JS DOM OVERRIDES
       ========================================================= */

    const upsellCards = shadowRoot.querySelectorAll(
      '.card.svelte-zwa04n, .card.svelte-zwa04n.svelte-zwa04n'
    );

    upsellCards.forEach(function(card) {
      card.style.setProperty('width', '250px', 'important');
      card.style.setProperty('min-width', '250px', 'important');
      card.style.setProperty('max-width', '250px', 'important');
      card.style.setProperty('flex', '0 0 250px', 'important');
      card.style.setProperty('box-sizing', 'border-box', 'important');
    });

    const specificAddButtons = shadowRoot.querySelectorAll(
      '.add-btn.svelte-zwa04n.svelte-zwa04n'
    );

    specificAddButtons.forEach(function(btn) {
      btn.style.setProperty('background', 'unset', 'important');
      btn.style.setProperty('background-color', 'unset', 'important');
    });


    const toggleBtns = shadowRoot.querySelectorAll(
      '.breakdown-toggle, ' +
      '.breakdown-toggle.svelte-16y1xw6, ' +
      '.estimated-total-section button'
    );

    toggleBtns.forEach(function(btn) {
      btn.style.setProperty('background', 'transparent', 'important');
      btn.style.setProperty('background-color', 'transparent', 'important');
      btn.style.setProperty('box-shadow', 'none', 'important');
      btn.style.setProperty('border', 'none', 'important');
      btn.style.setProperty('padding', '0', 'important');
    });


    const discountPills = shadowRoot.querySelectorAll('.discount-percentage');

    discountPills.forEach(function(pill) {
      pill.style.setProperty('background-color', THEME.discountPillBg, 'important');
      pill.style.setProperty('color', THEME.discountPillColor, 'important');
    });


    const addButtons = shadowRoot.querySelectorAll(
      '.add-btn, ' +
      '.add-btn.svelte-zwa04n, ' +
      '.card.svelte-zwa04n button, ' +
      '.upsell.svelte-10zz03f .add-to-cart'
    );

    addButtons.forEach(function(btn) {
      btn.style.setProperty('border', '1px solid rgba(97, 45, 15, 0.35)', 'important');
      btn.style.setProperty('color', THEME.brandBrown, 'important');
    });


    const productNames = shadowRoot.querySelectorAll(
      '.product-name.svelte-zwa04n.svelte-zwa04n, ' +
      '.card.svelte-zwa04n .product-name'
    );

    productNames.forEach(function(name) {
      name.style.setProperty('max-width', '100%', 'important');
      name.style.setProperty('width', '100%', 'important');
      name.style.setProperty('white-space', 'normal', 'important');
      name.style.setProperty('overflow', 'hidden', 'important');
      name.style.setProperty('text-overflow', 'ellipsis', 'important');
      name.style.setProperty('display', '-webkit-box', 'important');
      name.style.setProperty('-webkit-line-clamp', '2', 'important');
      name.style.setProperty('-webkit-box-orient', 'vertical', 'important');
      name.style.setProperty('line-height', '1.3', 'important');
      name.style.setProperty('height', '2.6em', 'important');
      name.style.setProperty('word-break', 'break-word', 'important');
    });


    const amountSaved = shadowRoot.querySelectorAll(
      '.amount-saved.svelte-yxrsu, ' +
      '.featured-offer.svelte-yxrsu .offer-details .amount-saved.svelte-yxrsu'
    );

    amountSaved.forEach(function(item) {
      item.style.setProperty('font-size', '10px', 'important');
      item.style.setProperty('background', 'rgb(97, 45, 15)', 'important');
      item.style.setProperty('background-color', 'rgb(97, 45, 15)', 'important');
      item.style.setProperty('color', '#fff', 'important');
      item.style.setProperty('padding', '3px 6px', 'important');
    });


    const offerIcons = shadowRoot.querySelectorAll(
      '.offer-icon.svelte-yxrsu, ' +
      '.offer-icon.svelte-yxrsu svg, ' +
      '.offer-icon.svelte-yxrsu svg path, ' +
      '.offer-icon.svelte-yxrsu svg g'
    );

    offerIcons.forEach(function(icon) {
      icon.style.setProperty('color', '#612d0f', 'important');
      icon.style.setProperty('fill', '#612d0f', 'important');
      icon.style.setProperty('stroke', '#612d0f', 'important');
    });


    const strikePrices = shadowRoot.querySelectorAll(
      '.price.svelte-zwa04n strike.svelte-zwa04n, ' +
      '.item-price strike, ' +
      'strike.compare-at-price, ' +
      '.compare-at-price.svelte-10zz03f'
    );

    strikePrices.forEach(function(price) {
      price.style.setProperty('color', '#62676c', 'important');
    });


    const discountBanners = shadowRoot.querySelectorAll('.discount-banner.svelte-zwa04n');

    discountBanners.forEach(function(banner) {
      banner.style.setProperty('background', '#ea8b48', 'important');
      banner.style.setProperty('background-color', '#ea8b48', 'important');
    });


    const checkoutBtns = shadowRoot.querySelectorAll(
      '.gokwik-checkout button, ' +
      'button.svelte-16y1xw6'
    );

    checkoutBtns.forEach(function(btn) {
      btn.style.setProperty('background-color', THEME.ctaOrange, 'important');
      btn.style.setProperty('color', THEME.white, 'important');

      btn.querySelectorAll('p, span').forEach(function(t) {
        t.style.setProperty('color', THEME.white, 'important');
      });
    });


    /* =========================================================
       COLOR WHITELIST PASS
       ========================================================= */

    shadowRoot.querySelectorAll('[style]').forEach(function(el) {
      if (el.tagName === 'STYLE') return;
      var c = el.style.color;
      if (!c) return;

      var cn = c.replace(/\s/g, '').toLowerCase();

      if (cn.indexOf('612d0f') !== -1 ||
          cn.indexOf('332219') !== -1 ||
          cn.indexOf('ea8b48') !== -1 ||
          cn.indexOf('fa493d') !== -1 ||
          cn.indexOf('62676c') !== -1 ||
          cn.indexOf('f39d52') !== -1 ||
          cn.indexOf('97,45,15') !== -1 ||
          cn.indexOf('51,34,25') !== -1 ||
          cn.indexOf('fff') !== -1 ||
          cn.indexOf('255,255,255') !== -1 ||
          cn === 'transparent' ||
          cn === 'inherit' ||
          cn === 'initial' ||
          cn === 'unset') return;

      el.style.setProperty('color', THEME.textDark, 'important');
    });
  }


  /* =========================================================
     SHADOW DOM OBSERVER
     ========================================================= */

  var observedRoots = [];

  function processHost(host) {
    if (!host || !host.shadowRoot) return;
    var sr = host.shadowRoot;
    applyStyles(sr);

    if (observedRoots.indexOf(sr) === -1) {
      observedRoots.push(sr);
      var applying = false;
      var timer = null;
      var innerObs = new MutationObserver(function(mutations) {
        if (applying) return;
        var relevant = mutations.some(function(m) {
          return Array.prototype.slice.call(m.addedNodes).some(function(n) {
            return n.id !== 'gokwik-origin-overrides';
          }) || Array.prototype.slice.call(m.removedNodes).length > 0;
        });
        if (!relevant) return;
        clearTimeout(timer);
        timer = setTimeout(function() {
          applying = true;
          applyStyles(sr);
          applying = false;
        }, 80);
      });
      innerObs.observe(sr, { childList: true, subtree: true });
    }
  }

  var observer = new MutationObserver(function() {
    document.querySelectorAll('shadow-dom-container').forEach(processHost);
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });


  /* =========================================================
     INITIAL APPLICATION
     ========================================================= */

  document.querySelectorAll('shadow-dom-container').forEach(processHost);

})();